import React from "react";
import {
    Avatar,
    Typography,
    Chip,
    Box,
    IconButton,
    Button,
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    Paper,
    Skeleton
} from "@mui/material";
import Grid from '@mui/material/Grid';

import {
    Logout,
    Settings,
    CreditCard,
    Groups,
    CameraAlt,
    MoreVert,
  } from "@mui/icons-material";

import { useUserPage } from "./useUserPage";
import {useUtil} from "./../../components/Util/useUtil"
import Tabs from "./Components/Tabs/Tabs";
import { Resumen } from './Components/DataResumen/Resumen';
import {UsuarioTable} from './Admin/TableUrer/UsuarioTable';
import FullScreenLoader from "../../components/Loading/FullScreenLoading";


export default function UserPage() {
    const {
        open,
        anchorEl,
        preview,
        inputRefImg,
        userData,
        tabSelect,
        perfil,
        loading,
        loadingAvatar,
        setLoadingAvatar,
        setTabSelect,
        inpinputFile,
        setAnchorEl,        
        handleAvatar,
        handleClick,
        handleClose,
        handleLogout,
        handleImageChange
    } = useUserPage();

    const {
        FormatDate,
    }=useUtil();    
    
    console.log('ariel-tab',perfil);
    if(loading){
        return (
            <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#f5f5f5",
                height: "360px",
            }}
            >
            <Paper
                elevation={3}
                sx={{
                width: 400,
                height: 270,
                p: 2,
                borderRadius: 3,
                marginTop: 2,
                marginBottom: 2,
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    <Grid size={{ xs: 12, md: 12, lg: 12 }} display="flex" justifyContent="end" alignItems="end">
                        <Skeleton variant="circular" width={40} height={40} animation="wave" />
                    </Grid>

                    <Grid container spacing={2} size={{ xs: 12, md: 12, lg: 12 }} display="flex" justifyContent="center" alignItems="center">
                        <Grid size={{ xs: 5, lg: 6 }}>
                            <Skeleton variant="circular" width={150} height={150} animation="wave" />
                        </Grid>
                        <Grid size={{ xs: 5, lg: 6 }}>
                            <Skeleton width="80%" height={30} animation="wave" />
                            <Skeleton width="60%" animation="wave" />
                            <Skeleton width="40%" animation="wave" />
                            <Skeleton
                            variant="rounded"
                            width={100}
                            height={30}
                            sx={{ mt: 1 }}
                            animation="wave"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            </Box>
        );
    }else{        
        return (
            <>
                <Box
                sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#f5f5f5",
                height:"360px"
                }}
                >
                    
                    <Paper 
                        elevation={3} 
                        sx={{ 
                            width: 450, 
                            height:300,
                            p: 1, 
                            borderRadius: 3, 
                            marginTop: 2,
                            marginBottom: 2 
                        }}>
                        <Grid container spacing={1} alignItems="center">
                            {/* Menú de usuario */}
                            <Grid  size={{ xs: 12, md: 12, lg: 12 }} display="flex" justifyContent="end" alignItems="end">
                                <Box alignItems={'flex-end'} sx={{with:'100%'}}>
                                    <IconButton onClick={handleClick}>
                                        {/* <Avatar src="/img/profile.jpg" sx={{ width: 48, height: 48 }} /> */}
                                        <MoreVert sx={{ width: 32, height: 32 }}/>
                                    </IconButton>
                                    <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose}>
                                        <Typography sx={{ px: 2, py: 1, fontWeight: "bold" }}>{userData?.nombre}</Typography>
                                        <Divider />
                                        <MenuItem>
                                        <ListItemIcon><Settings fontSize="small" /></ListItemIcon>
                                            Configuración
                                        </MenuItem>
                                        <MenuItem>
                                        <ListItemIcon><Groups fontSize="small" /></ListItemIcon>
                                            Mis equipos
                                        </MenuItem>
                                        <MenuItem>
                                        <ListItemIcon><CreditCard fontSize="small" /></ListItemIcon>
                                            Suscripción
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem onClick={handleLogout}>
                                        <ListItemIcon><Logout fontSize="small" /></ListItemIcon>
                                            Cerrar sesión
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                
                            </Grid>
                            <Grid container spacing={1} size={{ xs: 12, md: 12, lg: 12 }} display="flex" justifyContent="center" alignItems="center">
                                <Grid size={{ xs: 6, lg: 6}}>
                                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                        {loadingAvatar ? (
                                            <Skeleton variant="circular" width={150} height={150} animation="wave" />
                                        ) : (
                                            <Avatar
                                            src={preview || userData?.avatar}
                                            sx={{ width: 180, height: 180 }}
                                            onLoad={() => setLoadingAvatar(false)} // Se asegura de capturar la carga
                                            />
                                        )}
                                        <IconButton
                                        sx={{
                                            position: 'absolute',
                                            bottom: { xs: 8, sm: 10, lg: 10 }, // Ajuste de posición inferior en pantallas pequeñas y grandes
                                            right: { xs: 8, sm: 10, lg: 10 }, // Ajuste de posición a la derecha en pantallas pequeñas y grandes
                                            bgcolor: 'white',
                                            boxShadow: 1,
                                            p: 1,
                                            '&:hover': {
                                            bgcolor: 'white',
                                            boxShadow: 2,
                                            },
                                        }}
                                        onClick={inpinputFile}
                                        >
                                        <CameraAlt fontSize="small" color="primary" />
                                        </IconButton>
                                    </Box>
    
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={inputRefImg}
                                        onChange={handleImageChange}
                                        style={{ display: 'none' }}
                                    />
                                </Grid>
    
    
                                {/* Datos del usuario */}
                                <Grid size={{ xs: 5, lg: 5 }}>
                                    <Typography variant="h6" fontWeight="bold">{userData?.nombre} {userData?.apellido}</Typography>
                                    <Typography variant="body2" color="textSecondary">{FormatDate(userData?.fechanac)}</Typography>
                                    <Typography variant="body2" color="textSecondary">{userData?.usuario}</Typography>
                                    <Chip label={userData?.estado} color="success" sx={{ mt: 1 }} />
                                    <Chip label={userData?.perfil} variant="outlined" sx={{ mt: 1 }} />
                                    {
                                        (userData?.perfil=='admin')?(
                                            <>                                           
                                            </>
                                        ):(
                                            <Button variant="contained" color="error" startIcon={<CreditCard />} sx={{ mt: 1 }}>
                                                PAGAR
                                            </Button>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
                <Tabs
                    setTabSelect={setTabSelect}
                    tabSelect={tabSelect}
                    perfil={perfil}
                />
                <div style={{height: (tabSelect?.id===1)?('550px'):('650px')}}>
                <>
                    {(() => {
                        if(perfil=='admin'){
                             switch (tabSelect?.id) {
                                case 1:                         
                                    return <UsuarioTable/>
                                break;
                                default:
                                    return null;
                                }                                    
                        }else{
                            switch (tabSelect?.id) {
                            case 1:
                                return <Resumen userData={userData} />;                        
                            default:
                                return null;
                            }
                        }
                    })()}
                </>
                </div>
            </>
        );
    }
}
